import { useModule } from "src/modules/modules";
import { wrapAround } from "./util";

const fadeOut = (scene: Phaser.Scene, audio: Phaser.Sound.WebAudioSound | Phaser.Sound.HTML5AudioSound, duration: number = 0, onComplete?: Function) => {
    return new Promise((res, rej) => {
        scene.tweens.add({
            targets: audio,
            volume: 0,
            duration: duration,
            onComplete: () => {
                onComplete?.(audio);
                res(audio);
            }
        });
    })
}

const ascending = (baseKey: string, startIndex: number, endIndex: number) => {
    const { audio } = useModule();
    let currentIndex = startIndex;

    const play = (index: number) => audio.play(`${baseKey}${index}`);

    const previous = (indexOnly: boolean = false) => {
        currentIndex = wrapAround(currentIndex - 1, startIndex, endIndex);
        if (!indexOnly) play(currentIndex);
    }

    const next = (indexOnly: boolean = false) => {
        currentIndex = wrapAround(currentIndex + 1, startIndex, endIndex);
        if (!indexOnly) play(currentIndex);
    }

    return {
        play,
        previous,
        next
    }
}

export { fadeOut, ascending };